import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DocumentHal} from '../../models/HAL/document-hal.model';
import {SafeResourceUrl} from '@angular/platform-browser';
import {SafePipe} from '../../pipes/safe.pipe';
import {LoadingSpinnerService} from '../../services/loading-spinner.service';
import {Router} from '@angular/router';


@Component({
  selector: 'app-preview-document',
  imports: [
    SafePipe
  ],
  templateUrl: './preview-document.component.html',
  styleUrl: './preview-document.component.scss'
})
export class PreviewDocumentComponent implements OnInit, OnDestroy {

  @Input()
  document: DocumentHal | undefined;
  documentUrl: SafeResourceUrl | undefined;

  private readonly hideSpinnerTimeout?: ReturnType<typeof setTimeout>;
  private iframeLoadedCounter: number = 0;

  constructor(private readonly router: Router,
              private readonly httpClient: HttpClient,
              private readonly loadingSpinnerService: LoadingSpinnerService) {
    this.loadingSpinnerService.show();
    // Failsafe to hide spinner after 10 seconds
    this.hideSpinnerTimeout = setTimeout(() => {
      loadingSpinnerService.hide();
    }, 10000);
  }

  ngOnInit() {
    this.httpClient.get<Blob>(new DocumentHal(this.document)._links.getLink('file')?.href!, {responseType: "blob" as "json"}).subscribe({
      next: (response: Blob) => {
        this.documentUrl = globalThis.URL.createObjectURL(response);
      },
      error: () => {
        this.backToCase()
      }
    });
  }

  ngOnDestroy() {
    if (this.hideSpinnerTimeout) {
      clearTimeout(this.hideSpinnerTimeout);
    }
  }

  iframeLoaded() {
    this.iframeLoadedCounter++;
    if (this.iframeLoadedCounter >= 2) {
      this.loadingSpinnerService.hide();
    }
  }

  backToCase() {
    this.router.navigate([new DocumentHal(this.document)._links.getLink('case')?.getRoute()]).then();
  }
}
